export default {
  site_name: 'KakobuyFinds',
  site_tagline: 'Najlepsze Kakobuy Spreadsheet i Finds',
  nav_home: 'Strona główna',
  nav_articles: 'Artykuły',
  nav_categories: 'Kategorie',
  nav_guide: 'Poradnik',
  btn_browse: 'Przeglądaj',
  btn_learn_more: 'Dowiedz się więcej',
  btn_view_all: 'Zobacz wszystkie',
  btn_read_article: 'Czytaj artykuł',
  btn_back_home: 'Powrót na stronę główną',
  footer_rights: 'Wszelkie prawa zastrzeżone.',
  footer_disclaimer: 'Ta strona jest niezależnym przewodnikiem. Nie jesteśmy bezpośrednio powiązani z Kakobuy.',
  footer_guide: 'Poradnik',
  footer_categories: 'Kategorie',
  footer_articles: 'Artykuły',
  external_link_notice: 'Link zewnętrzny',
  category_select: 'Wybierz kategorię',
  category_all: 'Wszystkie kategorie',
};